import { Component, inject, OnInit } from '@angular/core';
import { AccountFilterData, WidgetFilterData } from '../../_shared/models';
import { AccountFilterComponent } from '../../_shared/components';
import { FilterService } from '../../_shared/services';
import { FuelLevelsComponent } from './components/fuel-levels/fuel-levels.component';
import { LowFuelLevelAlertsComponent } from './components/low-fuel-level-alerts/low-fuel-level-alerts.component';
import { FuelLevelMapComponent } from './components/fuel-level-map/fuel-level-map.component';
import { SearchComponent } from '../../_shared/components/filters/search/search.component';
import { isEmptyObject } from '../../_shared/helpers/object.helper';
import { BasePageComponent } from '../../_shared/components/page/base-page.component';
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-fuel-level',
  standalone: true,
  imports: [
    CommonModule,
    AccountFilterComponent,
    FuelLevelsComponent,
    LowFuelLevelAlertsComponent,
    FuelLevelMapComponent,
    SearchComponent,
    TranslocoPipe
  ],
  templateUrl: './fuel-level.component.html',
  styleUrl: './fuel-level.component.scss'
})
export class FuelLevelComponent extends BasePageComponent implements OnInit {
  private filterService: FilterService = inject(FilterService);
  public accountFilter: AccountFilterData = {} as AccountFilterData;
  public searchTerm: string = '';

  constructor() {
    super();
  }

  protected override getFilters(): any {
    return {
      ...this.accountFilter,
      searchTerm: this.searchTerm
    };
  }

  protected override applyPageFilterState(pageFilter: any): void {
    // Apply account filter
    this.accountFilter = { accountIds: pageFilter.accountIds } as AccountFilterData;
    this.searchTerm = pageFilter.searchTerm ?? '';
  }

  onAccountFilterChange(filter: AccountFilterData): void {
    this.accountFilter = filter;
    this.filterService.updateFilter(this.getFilters() as WidgetFilterData);
    this.updatePageFilterState();
  }

  onSearchTermUpdate(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filterService.updateSearchTerm(searchTerm);
    this.updatePageFilterState();
  }

  protected onRefresh(): void {
    this.onAccountFilterChange(this.accountFilter);
  }

  protected override shouldRefresh(): boolean {
    return !isEmptyObject(this.accountFilter);
  }
}